"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class TextToSpeechServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async getSpeech(params) {
        var _a;
        const expectedResponses = [200, 400, 422];
        const response = await this.requestMaker.makeRequest(`${this.url}/api/get-speech`, {
            method: 'POST',
            body: JSON.stringify(params)
        }, expectedResponses);
        if (response.status !== 200) {
            throw new Error((_a = response.json) === null || _a === void 0 ? void 0 : _a.reason);
        }
        return response.json;
    }
}
exports.default = TextToSpeechServiceClient;
//# sourceMappingURL=TextToSpeechServiceClient.js.map